/**
 *
 * Styles for WCCOfferDeliveryInfo
 *
 */

import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";

export const EstimatedDeliveryContainer = styled.div`
  box-shadow: 0 var(--gaq-size-space-3px) var(--dui-size-space-4x) 0
    var(--dui-color-gray-300);
  padding: var(--dui-size-space-10x);
`;

export const EstimatedDeliveryContainerText = styled(DhlText)`
  & > * {
    display: block;
    font-size: ${(props) => (props.isParagraph ? "2rem" : "1.5rem")};
    font-stretch: normal;
    margin-bottom: var(--dui-size-space-5x);
  }
`;
